export default {
    requests: [],
    requestsLoading: false,
    requestStatuses: [],
    requestTypes: [],
    requestAttachments: [],
    materials: [],
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        status_id : null,
        title : null,
        createdBy_id : null,
        assignedTo_id : null
    }
}